import { FixField } from "./fix-model";

export class FixDictionary {
  readonly name: string;
  readonly messages: Map<string, any>;
  private readonly header = new Map<number, boolean>();
  private readonly trailer = new Map<number, boolean>();
  private tags: Map<number, FixField>;

  constructor(
    name: string,
    header: Map<string, boolean>,
    trailer: Map<string, boolean>,
    messages: Map<string, any>,
    tags: Map<number, FixField>
  ) {
    this.name = name;
    header.forEach((v, k) => {
      this.header.set(parseInt(k), v);
    });
    trailer.forEach((v, k) => {
      this.trailer.set(parseInt(k), v);
    });
    this.messages = messages;
    this.tags = tags;
  }

  isHeaderTag(num: number): boolean {
    return this.header[num] !== undefined;
  }

  isTrailerTag(num: number): boolean {
    return this.trailer[num] !== undefined;
  }

  isGroupHeader(msgType: string, num: number): boolean {
    const message = this.messages[msgType];
    if (message === undefined) {
      return false;
    }
    const struct = message.s;
    if (!struct) return false;
    for (let i = 0; i < struct.length; i++) {
      if (struct[i].num === num) {
        return !!struct[i].gh;
      }
    }
    return false;
  }

  isAdmin(msgType: string): boolean {
    const message = this.messages[msgType];
    if (message === undefined) {
      return false;
    }
    return message.adm === true;
  }

  isGroupTag(msgType: string, num: number): boolean {
    const message = this.messages[msgType];
    if (message === undefined) {
      return false;
    }
    const struct = message.s;
    if (!struct) return false;
    for (let i = 0; i < struct.length; i++) {
      const gs = struct[i].s;
      if (gs === undefined) continue;
      for (let j = 0; j < gs.length; j++) {
        if (gs[j] === undefined) {
          continue;
        }
        if (gs[j].num === num) {
          return !0;
        }
      }
    }
    return !1;
  }

  isGroupStart(msgType: string | undefined, num: number): boolean {
    const message = this.messages[msgType];
    if (message === undefined) {
      return false;
    }
    const struct = message.s;
    if (!struct) return false;
    for (let i = 0; i < struct.length; i++) {
      if (!!struct[i].gh) {
        const groupStruct = struct[i].s;
        if (!!groupStruct[0] && groupStruct[0].num === num) {
          return true;
        }
      }
    }
    return false;
  }
}
